<template>
    <multiselect
        v-model                = "otherServiceSelected"
        v-bind:options         = "subTitleOnly ? groupedItems : items"
        v-bind:loading         = "isLoadingItems"
        v-bind:allow-empty     = "false"
        v-bind:disabled        = "!otherServiceTypeID"
        v-bind:custom-label    = "subTitleOnly ? otherSubTitleOnlyLabel : otherLabel"
        v-bind:internal-search = "false"

        placeholder    = "Zusatzleistung auswählen"
        track-by       = "id"
        group-values   = "items"
        group-label    = "type"
        select-label   = ""
        deselect-label = "Löschen"

        v-on:search-change = "otherServiceSearch"
    >
        <template slot="noResult">Keine passenden Leistungsträger</template>
        <template slot="option" slot-scope="props">
            <template v-if="props.option.$isLabel">
                <strong>{{ props.option.$groupLabel }}</strong>
            </template>
            <div class="columns" v-else>
                <div class="column">
                    {{subTitleOnly ? otherSubTitleOnlyLabel(props.option) : otherLabel(props.option)}}
                    {{getRelevantPrice(props.option) ? '(' + getRelevantPrice(props.option).formatted + ')' : ''}}
                    <div style="right:-10px; position:relative;" v-if="props.option.menu && isHover === props.option.id">
                        <div v-html="props.option.menu.content"></div>
                    </div>
                </div>
                <button
                    v-on:mouseenter="isHover = props.option.id"
                    v-on:mouseleave="isHover = null"
                    class="column is-narrow"
                    v-if="props.option.menu && props.option.menu.content"
                    title="Preview"
                ><i class="material-icons">search</i></button>
            </div>
        </template>
        <span slot="caret">
            <a
                class  = "multiselect-crud-link"
                href   = "/others?add"
                title  = "Fügen Sie eine neue Leistungsträger hinzu"
                target = "_blank"
            ><i class="material-icons">add</i></a>
        </span>
    </multiselect>
</template>


<script>
import axios           from 'axios';
import debounce        from 'lodash/debounce';
import moment          from 'moment';
import Multiselect     from '@components/form/Multiselect';
import { notifyError } from '@components/Notification';
import mixins from "@orders/placeholders/components/forms/mixins";
import {getAxios} from "@api";
import Popover from "@components/Popover.vue";


const emptyObject = { id: -1, provider: { name: 'No-Name' } };


export default {
    mixins: [mixins],
    props: {
        value: {},
        otherServiceTypeID: { required: true },
        providerID: { required: false },
        agencyID: {required: false},
        agencyExist: {default: null},
        placeholderInfo: {  default: () => ({}) },
        subTitleOnly: {default: false},
        preselectNoSubtitle: {default: false},
        referenceDate: {default: null}
    },


    data: function () {
        return {
            isHover: null,
            items: [
                {
                    type: 'No-Name',
                    items: [emptyObject]
                },
                {
                    type: 'Leistungsträger',
                    items: []
                }
            ],
            items2: [
                {
                    type: 'Zusatztitel',
                    items: []
                }
            ],

            queryString:          '',
            otherServiceSelected: null,
            isLoadingItems:       false
        }
    },


    computed: {
        groupedItems: function () {
            const data = this.items2[0].items;
            const groups = {};
            data.forEach(item => {
                let key;
                const startAt = this.getRelevantStartAt(item);
                if (startAt) {
                    key = String(moment(startAt, 'DD.MM.YYYY').year());
                } else {
                    key = 'Kalkulationspreis';
                }
                if (!groups[key]) {
                    groups[key] = { type: key, items: [] };
                }
                groups[key].items.push(item);
            });
            // Dates sorted newest first, then Kalkulationspreis last
            const result = [];
            const dateKeys = Object.keys(groups).filter(k => k !== 'Kalkulationspreis').sort((a, b) => {
                return Number(b) - Number(a);
            });
            dateKeys.forEach(key => result.push(groups[key]));
            if (groups['Kalkulationspreis']) {
                result.push(groups['Kalkulationspreis']);
            }
            return result;
        },

        referenceYear: function () {
            if (!this.referenceDate) return null;
            return moment(this.referenceDate, 'DD.MM.YYYY HH:mm:ss').year();
        },
    },


    methods: {

        getRelevantPriceGroup (other) {
            if (!other.priceGroups || other.priceGroups.length === 0) return null;
            if (!this.referenceDate) return other.priceGroups[0];

            const refDate = moment(this.referenceDate, 'DD.MM.YYYY HH:mm:ss');

            for (const group of other.priceGroups) {
                if (!group.timePeriods) continue;
                for (const period of group.timePeriods) {
                    const start = moment(period.startAt, 'DD.MM.YYYY');
                    const end = period.endAt ? moment(period.endAt, 'DD.MM.YYYY') : null;
                    if (refDate.isSameOrAfter(start) && (!end || refDate.isSameOrBefore(end))) {
                        return group;
                    }
                }
            }

            return other.priceGroups[0];
        },

        getRelevantPrice (other) {
            const group = this.getRelevantPriceGroup(other);
            if (!group || !group.providerPrices || group.providerPrices.length === 0) {
                return other.menu ? other.menu.price : null;
            }
            const buyPrice = group.providerPrices.find(p => p.priceType === 'buy_price');
            return buyPrice ? buyPrice.price : group.providerPrices[0].price;
        },

        getRelevantStartAt (other) {
            const group = this.getRelevantPriceGroup(other);
            if (!group || !group.timePeriods || group.timePeriods.length === 0) {
                return other.menu ? other.menu.startAt : null;
            }
            if (!this.referenceDate) return group.timePeriods[0].startAt;

            const refDate = moment(this.referenceDate, 'DD.MM.YYYY HH:mm:ss');
            for (const period of group.timePeriods) {
                const start = moment(period.startAt, 'DD.MM.YYYY');
                const end = period.endAt ? moment(period.endAt, 'DD.MM.YYYY') : null;
                if (refDate.isSameOrAfter(start) && (!end || refDate.isSameOrBefore(end))) {
                    return period.startAt;
                }
            }
            return group.timePeriods[0].startAt;
        },

        otherSubTitleOnlyLabel (other) {
            let subtitle = '';
            subtitle += other.subtitle ? other.subtitle : 'Kalkulationspreis';
            return subtitle
        },

        otherLabel: function (other) {
            let subtitle = '';

            subtitle += other.agency ? ' (' + other.agency.name + ')' : '';
            subtitle += other.subtitle ? ' (' + other.subtitle + ')' : '';
            if (other.provider) {
                subtitle += other.provider.place && other.provider.place.destination  ? ' (' + other.provider.place.destination.name + ')' : '';
                return other.provider.name + subtitle ;

            } else {
                return 'No-Name' + subtitle;
            }
        },


        otherServiceSearch: debounce(function (query, isTriggerAction = false) {
            if (this.otherServiceTypeID || isTriggerAction) {
                this.queryString = query;

                this.isLoadingItems = true;
                this.callCancelRequest();



                getAxios('other_services', {
                    'provider[exists]': true,
                    'agency[exists]': this.agencyExist,
                    'provider.name': query,
                    'otherServiceType.id': this.otherServiceTypeID,
                    'provider.id': this.providerID,
                    'agency.id': this.agencyID,

                    ...this.placeholderInfo.area && {
                        'providerWithPlace.place.area.id': this.placeholderInfo.area.id,
                    },
                    ...this.placeholderInfo.place && {
                        'providerWithPlace.place.id': this.placeholderInfo.place.id,
                    },
                    ...this.placeholderInfo.destination && {
                        'providerWithPlace.place.destination.id': this.placeholderInfo.destination.id,
                    },
                    '_groups': ['provider_read', 'agency_read', 'place_read', 'area_read', 'destination_read', 'provider_other_service:menu', 'menu', 'money_read', 'other_service_read', 'provider_price_group:price_time_period', 'price_time_period', 'provider_price_group:provider_price', 'provider_price'],
                    '_order[menu.type]': 'asc'
                }).then(response => {
                    if(this.subTitleOnly) {
                        this.items2[0].items = response.data;
                    } else {
                        this.items[1].items = response.data;
                    }

                    if (this.preselectNoSubtitle && this.referenceDate) {
                        const kalkulationsItems = response.data.filter(i => i.subtitle === 'Kalkulationspreis' || !i.subtitle);
                        const refDate = moment(this.referenceDate, 'DD.MM.YYYY HH:mm:ss');
                        const item = kalkulationsItems.find(i => {
                            if (!i.priceGroups || i.priceGroups.length === 0) return false;
                            return i.priceGroups.some(group => {
                                if (!group.timePeriods) return false;
                                return group.timePeriods.some(period => {
                                    const start = moment(period.startAt, 'DD.MM.YYYY');
                                    const end = period.endAt ? moment(period.endAt, 'DD.MM.YYYY') : null;
                                    return refDate.isSameOrAfter(start) && (!end || refDate.isSameOrBefore(end));
                                });
                            });
                        });
                        if (item) {
                            this.otherServiceSelected = item;
                        }
                    }

                    }, error => { if(!axios.isCancel(error)) {
                        notifyError('Die Anbieter konnten nicht geladen werden! Server error!');
                    } })
                    .then(() => { this.isLoadingItems = false; });
            }
        }, 900)
    },


    created: function () {
        this.otherServiceSearch(this.queryString, true);
    },


    watch: {
        otherServiceTypeID: function (newValue, oldValue) {
            if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                this.otherServiceSearch(this.queryString, true);
            }
        },

        providerID: function (newValue, oldValue) {
            if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                this.otherServiceSearch(this.queryString, true);
            }
        },

        agencyID: function (newValue, oldValue) {
            if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                this.otherServiceSearch(this.queryString, true);
            }
        },

        placeholderInfo: function (newValue, oldValue) {
            if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                this.otherServiceSearch(this.queryString, true);
            }
        },


        value: {
            handler: function (newValue, oldValue) {
                if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
                    if (this.value) {
                        this.otherServiceSelected = JSON.parse(JSON.stringify(this.value));

                    } else {
                        this.otherServiceSelected = emptyObject;
                    }
                }
            },
            deep: true,
            immediate: true
        },


        otherServiceSelected: {
            handler: function (value) {
                this.$emit('input', value.id !== -1 ? value : null);
            },
            deep: true
        }
    },


    components: {
        Popover,
        Multiselect
    }
}
</script>
